// Evaluated just before Rapier's module (see ./index.ts): hide FinalizationRegistry so the
// wasm-bindgen wrappers created at module load fall back to no-op registration.
const g = globalThis as { FinalizationRegistry?: unknown; __rapierSavedFR?: unknown };
g.__rapierSavedFR = g.FinalizationRegistry;
g.FinalizationRegistry = undefined;
export {};
